<template>
<div class="container">
    <div class="title">AI罚单自动识别</div>
    <div class="description">线上极速办理</div>
    <div class="ad"></div>
    <div class="btn_green" @click="loginAbchina">立即办理</div>
   
</div>
</template>
<script>
export default {
  mounted() {
      if(this.$route.query&&this.$route.query.from){
          this.from = this.$route.query.from
      }
      document.getElementById('title').innerHTML = '罚单代办';
  },
  data() {
    return {
     from: '',
    };
  },
  methods: {
    loginAbchina: function() {
        let state = Math.random();
        let redirect_uri = btoa(encodeURIComponent('https://mys4s.cn/static/vio/index.html#/ticket?channel=abchina&source=abchina'));
        const urlStr = 'https://www.abchina.com/luascript/oauthLogin/{"client_id":"7708e730-c9ac-48a5-b363-b0728ed068e5","redirect_uri":"https://mys4s.cn/v5/auth/'+ redirect_uri +'","state":"'+ state +'","scope":"openid","response_type":"code"}';
        window.location.href = urlStr;
    },
  }
};
</script>
<style scoped>
page {
    background: #fff;
}
.container {
    width: 100%;
    height: 100%;
    background: #fff;
}
.title {
    font-size: 30px;
    font-weight: 600;
    color: #0bd4b8;
    line-height: 42px;
    text-align: center;
    padding: 16px 0 5px 0;
    font-family: PingFangSC, PingFangSC-Semibold;
}
.description {
    font-size: 18px;
    font-weight: 300;
    text-align: center;
    color: #474747;
    line-height: 25px;
    letter-spacing: 1px;
    font-family: PingFangSC, PingFangSC-Light;
    margin-bottom: 33px;
}
.ad{
    width: 100%;
    height: 350px;
    background: url(https://app.s4s.cn/razio/ad_ticket.png) no-repeat center 0;
    background-size: cover;
    margin-bottom: 60px;
}
.btn_green{
    width: 300px;
    height: 48px;
    background: #0bd4b8;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    line-height: 48px;
    margin: 0 auto;
}

</style>
